/*!
 * CarWrapVinyl.com · Builder C · ROI Lab calculators (vanilla JS, no dependencies)
 * Definitions (inputs, defaults, min/max/step, units, help, sources, outputs, disclaimers,
 * how-we-calculate) are generated verbatim from content/pages/roi-lab.json -> calculators.
 * Section ids -> roi-lab ids:
 *   fleet_value         -> fleet-media-value
 *   cost_per_impression -> cost-per-impression
 *   ownership_cost      -> wrap-paint-ppf
 *   break_even          -> break-even-customers
 * Mount: <div data-cwv-calc="fleet_value"> inside [data-cwv-calc-section]; optional
 * <script type="application/json" data-cwv-calc-config> overrides defaults/constants.
 */
(function (root) {
  'use strict';

  var CWV = root.CWV = root.CWV || {};
  if (CWV.calc && CWV.calc.__loaded) { return; }

  /* ------------------------------------------------------------------ data */
  /* BEGIN GENERATED: roi-lab.json calculators (do not edit by hand) */
  var SRC = [{"id":"fleet-media-value","title":"Fleet Wrap Value Calculator","purpose":"Estimate the media-equivalent value of your wrapped fleet over the life of the wraps.","inputs":[{"id":"vehicle_rows","label":"Your vehicles","type":"rows","default":[{"vehicle_type":"full_van","count":5,"price":3900}],"min":1,"max":6,"step":null,"unit":"rows","help":"Add up to six rows for a mixed fleet. Picking a type fills in its starting price and coverage. You can overwrite the price with your quote.","source":"Structure from Ardor's existing calculator.","row_fields":[{"id":"vehicle_type","label":"Vehicle and coverage","type":"select","options":[{"value":"lettering","label":"Lettering and logos","price":350,"coverage":"lettering","source":"Pricing doc: lettering / logos from $350"},{"value":"first_package","label":"First truck & van package (door lettering)","price":495,"coverage":"lettering","source":"Pricing doc: first truck & van packages from $495"},{"value":"spot","label":"Spot graphics","price":615,"coverage":"lettering","source":"Pricing doc: spot graphics from $615"},{"value":"partial_car","label":"Partial wrap, car","price":2500,"coverage":"partial","source":"Pricing doc: car wraps (partial) from $2,500"},{"value":"full_car","label":"Full wrap, car","price":3000,"coverage":"full","source":"Pricing doc: full vehicle wraps (cars) from $3,000"},{"value":"full_van","label":"Full wrap, van","price":3900,"coverage":"full","source":"Pricing doc: van wraps from $3,900"},{"value":"full_pickup","label":"Full wrap, pickup","price":4000,"coverage":"full","source":"Pricing doc: truck wraps (full pickup) from $4,000"},{"value":"box_truck","label":"Box truck wrap","price":4500,"coverage":"full","source":"Pricing doc: box truck wraps $4,500-$8,500+, priced by box length and sides. Default is the low end; enter your quote."},{"value":"other","label":"Other (trailer, SUV, semi, food truck): enter your quote","price":null,"coverage":"full","source":"No published price. Quoted per vehicle."}],"default":"full_van"},{"id":"count","label":"How many","type":"number","default":5,"min":0,"max":500,"step":1,"unit":"vehicles"},{"id":"price","label":"Price per vehicle","type":"currency","default":3900,"min":0,"max":50000,"step":50,"unit":"USD","help":"Starting price for the type you picked. Replace it with your quote."}]},{"id":"design_cost","label":"Design (one-time)","type":"currency","default":1000,"min":0,"max":20000,"step":50,"unit":"USD","help":"Design is quoted separately. Full wrap design starts from $1,000 and partial from $650. Assumes one design adapted across the fleet; your quote may differ.","source":"Pricing doc (design always separate: partial from $650, full from $1,000). One design for the fleet is an assumption."},{"id":"base_impressions","label":"Impressions per vehicle per day at 50 miles","type":"number","default":5000,"min":0,"max":100000,"step":500,"unit":"impressions/day","help":"An impression is one chance for someone to see the vehicle. Raise or lower this to match your routes.","source":"Assumption. A conservative placeholder; we could not trace a published impression study we could open."},{"id":"area","label":"Driving area","type":"select","options":[{"value":"seattle_eastside","label":"Seattle & Eastside","factor":1.4},{"value":"suburbs_highways","label":"Suburbs & highways","factor":1.0},{"value":"rural","label":"Rural routes","factor":0.6}],"default":"suburbs_highways","min":null,"max":null,"step":null,"unit":"multiplier","help":"Busier roads mean more people see the vehicle. The multiplier scales the impressions above.","source":"Ardor assumption: relative traffic density, not measured. Ratios match the area presets on Ardor's existing calculator."},{"id":"miles_per_day","label":"Average miles per vehicle per day","type":"number","default":50,"min":1,"max":500,"step":5,"unit":"miles","help":"Impressions scale with distance: 100 miles counts double the 50-mile baseline.","source":"Assumption. Same 50-mile baseline as Ardor's existing calculator."},{"id":"coverage_full","label":"Coverage factor: full wrap","type":"number","default":1.0,"min":0,"max":1,"step":0.05,"unit":"factor","help":"How visible a full wrap is, as the baseline.","source":"Ardor assumption carried from the existing calculator. Not measured."},{"id":"coverage_partial","label":"Coverage factor: partial wrap","type":"number","default":0.75,"min":0,"max":1,"step":0.05,"unit":"factor","help":"A partial counts as 75% as visible as a full wrap by default.","source":"Ardor assumption carried from the existing calculator. Not measured."},{"id":"coverage_lettering","label":"Coverage factor: lettering or spot graphics","type":"number","default":0.4,"min":0,"max":1,"step":0.05,"unit":"factor","help":"Lettering and spot graphics count as 40% as visible as a full wrap by default.","source":"Ardor assumption carried from the existing calculator. Not measured."},{"id":"years","label":"Years the wraps run","type":"select","options":[{"value":3,"label":"3 years"},{"value":5,"label":"5 years"},{"value":7,"label":"7 years"}],"default":5,"min":3,"max":7,"step":null,"unit":"years","help":"Printed wraps typically last 5 to 7 years with proper care, up to 8 on vertical surfaces.","source":"Assumption, informed by Ardor's stated wrap life."},{"id":"days_per_year","label":"Days on the road","type":"select","options":[{"value":250,"label":"5 days a week (250 days a year)"},{"value":300,"label":"6 days a week (300 days a year)"},{"value":350,"label":"7 days a week (350 days a year)"}],"default":250,"min":250,"max":350,"step":null,"unit":"days/year","help":"Count only days the vehicles are out driving.","source":"Assumption carried from Ardor's existing calculator."},{"id":"comparison_cpm","label":"Comparison cost per 1,000 impressions (CPM)","type":"currency","default":3.0,"min":0,"max":100,"step":0.25,"unit":"USD per 1,000 impressions","help":"What you'd pay another medium to reach 1,000 people. Use a CPM from a real media quote: billboard, radio, mailers or online ads.","source":"Assumption. A round placeholder, not a published benchmark."}],"outputs":[{"id":"fleetImpressions","label":"Estimated impressions over the wrap life","format":"integer_compact"},{"id":"investment","label":"Wrap investment (starting prices + design)","format":"currency_0"},{"id":"mediaValue","label":"Estimated media-equivalent value","format":"currency_0"},{"id":"valueToCost","label":"Media-equivalent value per $1 of wrap","format":"ratio_2"},{"id":"ownCpm","label":"Your cost per 1,000 impressions","format":"currency_2"},{"id":"costPerVehicleDay","label":"Cost per vehicle per day on the road","format":"currency_2"},{"id":"daysToMatch","label":"Operating days until media-equivalent value equals the investment","format":"integer"}],"disclaimer":"Estimated media-equivalent value is what the same impressions would cost at the CPM you entered. It is not revenue or profit, and an impression is a chance to be seen, not a lead. Impression and CPM defaults are assumptions you should replace with your own. Prices are Ardor's starting prices before fleet pricing, and design is quoted separately. Your quote depends on your vehicles, coverage and design. Fleet pricing: ask us.","how_we_calculate":["Each vehicle's daily impressions = your impressions at 50 miles x the driving-area multiplier x (your miles / 50) x the coverage factor for that vehicle's wrap.","Fleet impressions = the sum across your vehicles x days on the road per year x years.","Investment = each vehicle's price x how many, plus one design fee.","Media-equivalent value = fleet impressions / 1,000 x the comparison CPM you entered.","Your cost per 1,000 impressions = investment / (fleet impressions / 1,000).","Every input above shows where its default came from. Change any of them and the results update."]},{"id":"cost-per-impression","title":"Cost per Impression over the Wrap's Life","purpose":"See what one wrap costs per 1,000 impressions, per day and per month over its life.","inputs":[{"id":"vehicles","label":"Number of vehicles","type":"number","default":1,"min":1,"max":500,"step":1,"unit":"vehicles","help":"Same wrap on each vehicle.","source":"Your input."},{"id":"wrap_price","label":"Wrap price per vehicle","type":"currency","default":3900,"min":0,"max":50000,"step":50,"unit":"USD","help":"Starting prices: car from $3,000, van from $3,900, pickup from $4,000, partial car from $2,500. Replace with your quote.","source":"Pricing doc: van wraps from $3,900."},{"id":"design_cost","label":"Design (one-time)","type":"currency","default":1000,"min":0,"max":20000,"step":50,"unit":"USD","help":"Design is quoted separately: full from $1,000, partial from $650.","source":"Pricing doc."},{"id":"include_removal","label":"Include removal at the end","type":"toggle","default":false,"min":null,"max":null,"step":null,"unit":"on/off","help":"Add the cost of taking the wrap off when it's done.","source":"Your choice."},{"id":"removal_cost","label":"Removal per vehicle","type":"currency","default":500,"min":0,"max":5000,"step":50,"unit":"USD","help":"Wrap removal starts from $500.","source":"Pricing doc: wrap removal from $500."},{"id":"years","label":"Years the wrap runs","type":"number","default":5,"min":1,"max":10,"step":1,"unit":"years","help":"Printed wraps typically last 5 to 7 years with proper care, up to 8 on vertical surfaces and about 3 on hoods and roofs.","source":"Assumption, informed by Ardor's stated wrap life. 3M and Avery Dennison rate unprinted film on vertical surfaces at 10 years; printed, laminated and horizontal surfaces last less."},{"id":"days_per_year","label":"Days driven per year","type":"number","default":250,"min":1,"max":365,"step":1,"unit":"days","help":"250 = five days a week.","source":"Assumption carried from Ardor's existing calculator."},{"id":"miles_per_day","label":"Miles driven per day","type":"number","default":50,"min":1,"max":500,"step":5,"unit":"miles","help":"Average for one vehicle.","source":"Assumption."},{"id":"impressions_per_mile","label":"Impressions per mile","type":"number","default":100,"min":0,"max":5000,"step":10,"unit":"impressions/mile","help":"100 per mile at 50 miles = 5,000 impressions a day. Use the sensitivity table to see half and double.","source":"Assumption. A conservative placeholder; no published study we could open."},{"id":"coverage","label":"Coverage","type":"select","options":[{"value":1.0,"label":"Full wrap (1.00)"},{"value":0.75,"label":"Partial wrap (0.75)"},{"value":0.4,"label":"Lettering or spot graphics (0.40)"}],"default":1.0,"min":0,"max":1,"step":null,"unit":"factor","help":"Less coverage, fewer people notice.","source":"Ardor assumption carried from the existing calculator. Not measured."},{"id":"comparison_cpm","label":"Comparison CPM","type":"currency","default":3.0,"min":0,"max":100,"step":0.25,"unit":"USD per 1,000 impressions","help":"The CPM from a real media quote you have: billboard, radio, mailers or online ads.","source":"Assumption. A round placeholder, not a published benchmark."}],"outputs":[{"id":"totalCost","label":"Total cost (wraps + design + removal if on)","format":"currency_0"},{"id":"lifeImpressions","label":"Estimated impressions over the wrap's life","format":"integer_compact"},{"id":"cpm","label":"Your cost per 1,000 impressions","format":"currency_2"},{"id":"costPerDay","label":"Cost per vehicle per driving day","format":"currency_2"},{"id":"costPerMonth","label":"Cost per vehicle per month","format":"currency_2"},{"id":"sameReachCost","label":"Same reach at your comparison CPM","format":"currency_0"},{"id":"breakEvenPerVehicleDay","label":"Impressions per vehicle per day to match your comparison CPM","format":"integer"},{"id":"sensitivity","label":"Your CPM at half and double the impressions","format":"table"}],"disclaimer":"An impression is a chance to be seen, not a lead or a sale. Impressions per mile and the comparison CPM are assumptions; replace them with your own. 'Same reach' is a comparison, not revenue. Prices are Ardor's starting prices, and design is quoted separately.","how_we_calculate":["Total cost = wrap price x vehicles + design, plus removal if you switch it on.","Daily impressions per vehicle = miles per day x impressions per mile x coverage.","Lifetime impressions = daily impressions x vehicles x days per year x years.","Your CPM = total cost / (lifetime impressions / 1,000).","Same reach = lifetime impressions / 1,000 x your comparison CPM.","The sensitivity table reruns your CPM at half and double the impressions per mile, so you can see how much the answer depends on that one assumption."]},{"id":"wrap-paint-ppf","title":"Wrap vs Paint vs PPF over Ownership","purpose":"Spread the cost of a wrap, a repaint and paint protection film over the years you'll own the vehicle.","inputs":[{"id":"years","label":"Years you'll own the vehicle","type":"number","default":5,"min":1,"max":15,"step":1,"unit":"years","help":"How long you plan to keep it.","source":"Your input."},{"id":"vehicles","label":"Vehicles","type":"number","default":1,"min":1,"max":500,"step":1,"unit":"vehicles","help":"Same treatment on each.","source":"Your input."},{"id":"wrap_cost","label":"Wrap price per vehicle","type":"currency","default":4000,"min":0,"max":50000,"step":50,"unit":"USD","help":"Full car wraps start from $3,000, and cars typically run $3,000-$5,000. Replace with your quote.","source":"Pricing doc range for cars ($3,000-$5,000). $4,000 is a mid-range assumption."},{"id":"wrap_life","label":"Wrap life","type":"number","default":5,"min":1,"max":10,"step":1,"unit":"years","help":"Printed wraps typically last 5 to 7 years with proper care.","source":"Assumption, informed by Ardor's stated wrap life."},{"id":"rewrap","label":"Re-wrap when it wears out","type":"toggle","default":true,"min":null,"max":null,"step":null,"unit":"on/off","help":"Off counts one wrap only.","source":"Your choice."},{"id":"removal_cost","label":"Removal per wrap","type":"currency","default":500,"min":0,"max":5000,"step":50,"unit":"USD","help":"Charged each time a worn wrap comes off before a new one.","source":"Pricing doc: wrap removal from $500."},{"id":"remove_at_end","label":"Remove the wrap when you sell","type":"toggle","default":false,"min":null,"max":null,"step":null,"unit":"on/off","help":"Adds one more removal at the end.","source":"Your choice."},{"id":"repaint_cost","label":"Repaint price per vehicle","type":"currency","default":null,"min":0,"max":100000,"step":100,"unit":"USD","help":"Enter a quote from a body shop. We leave this blank because paint prices vary too much to guess.","source":"Your quote. No default."},{"id":"paint_life","label":"Paint life","type":"number","default":10,"min":1,"max":20,"step":1,"unit":"years","help":"Ask the body shop what its warranty covers.","source":"Assumption."},{"id":"ppf_cost","label":"PPF price per vehicle","type":"currency","default":null,"min":0,"max":50000,"step":100,"unit":"USD","help":"Enter an installer's quote for the coverage you want.","source":"Your quote. No default."},{"id":"ppf_life","label":"PPF life","type":"number","default":10,"min":1,"max":15,"step":1,"unit":"years","help":"3M backs its Protection Wrap Film with a 10-year consumer warranty. Check your installer's film and terms.","source":"3M Protection Wrap Film product bulletin (10-year consumer warranty). Used as a default assumption."},{"id":"downtime_days_wrap","label":"Days without the vehicle: wrap","type":"number","default":2,"min":0,"max":30,"step":1,"unit":"days","help":"Most full wraps take 1 to 5 days at our shop.","source":"Assumption within Ardor's stated 1 to 5 days."},{"id":"downtime_days_paint","label":"Days without the vehicle: repaint","type":"number","default":null,"min":0,"max":60,"step":1,"unit":"days","help":"Ask the body shop.","source":"Your input. No default."},{"id":"downtime_days_ppf","label":"Days without the vehicle: PPF","type":"number","default":null,"min":0,"max":30,"step":1,"unit":"days","help":"Ask the installer.","source":"Your input. No default."},{"id":"value_per_downtime_day","label":"Cost of a day without the vehicle","type":"currency","default":0,"min":0,"max":10000,"step":25,"unit":"USD/day","help":"For a work vehicle, the revenue you lose per day it's parked. Leave at 0 for a personal car.","source":"Your input."},{"id":"adjust_wrap","label":"Resale or lease adjustment: wrap","type":"currency","default":0,"min":-50000,"max":50000,"step":100,"unit":"USD","help":"Positive if you expect to gain value (for example, avoided lease charges). We don't build one in.","source":"Your input. No verified source for a default."},{"id":"adjust_paint","label":"Resale or lease adjustment: repaint","type":"currency","default":0,"min":-50000,"max":50000,"step":100,"unit":"USD","help":"Positive if you expect to gain value, negative if you expect to lose it.","source":"Your input. No verified source for a default."},{"id":"adjust_ppf","label":"Resale or lease adjustment: PPF","type":"currency","default":0,"min":-50000,"max":50000,"step":100,"unit":"USD","help":"Positive if you expect to gain value, negative if you expect to lose it.","source":"Your input. No verified source for a default."}],"outputs":[{"id":"netWrap","label":"Wrap: total over ownership","format":"currency_0"},{"id":"netPaint","label":"Repaint: total over ownership","format":"currency_0_or_prompt"},{"id":"netPpf","label":"PPF: total over ownership","format":"currency_0_or_prompt"},{"id":"perYear","label":"Per year, each option","format":"currency_0"},{"id":"perMonth","label":"Per month, each option","format":"currency_2"},{"id":"wrapLifeSensitivity","label":"Wrap total if it lasts 3, 5 or 7 years","format":"table"}],"disclaimer":"A wrap, a repaint and PPF do different jobs: a wrap changes color or carries graphics, paint replaces the finish, and PPF guards it. This calculator compares cost only. Paint and PPF stay blank until you enter real quotes. We don't build in resale or lease effects because we haven't found a source we trust. Tax treatment varies; ask your accountant.","how_we_calculate":["Wrap cycles = years of ownership / wrap life, rounded up (or 1 if re-wrap is off).","Each extra cycle adds one removal, plus one more if you remove the wrap at the end.","Repaints and PPF are counted the same way: years / life, rounded up, x the price you entered.","Downtime adds days without the vehicle x what a day costs you. Adjustments subtract any value you expect to gain.","Per year and per month divide each total by your years of ownership."]},{"id":"break-even-customers","title":"Break-even Customers","purpose":"Count how many new customers it takes to pay for the wrap from real job profit.","inputs":[{"id":"vehicles","label":"Vehicles","type":"number","default":1,"min":1,"max":500,"step":1,"unit":"vehicles","help":"How many vehicles you're wrapping.","source":"Your input."},{"id":"wrap_price","label":"Wrap price per vehicle","type":"currency","default":3900,"min":0,"max":50000,"step":50,"unit":"USD","help":"Van from $3,900, pickup from $4,000, car from $3,000. Replace with your quote.","source":"Pricing doc: van wraps from $3,900."},{"id":"design_cost","label":"Design (one-time)","type":"currency","default":1000,"min":0,"max":20000,"step":50,"unit":"USD","help":"Quoted separately: full from $1,000, partial from $650.","source":"Pricing doc."},{"id":"other_upfront","label":"Other upfront costs","type":"currency","default":0,"min":0,"max":50000,"step":50,"unit":"USD","help":"Anything else you'd count, such as a trackable phone number.","source":"Your input."},{"id":"upkeep_per_year","label":"Cleaning and upkeep per year","type":"currency","default":0,"min":0,"max":10000,"step":25,"unit":"USD/year","help":"Hand washes and care products, if you want to count them.","source":"Your input."},{"id":"include_removal","label":"Include removal at the end","type":"toggle","default":false,"min":null,"max":null,"step":null,"unit":"on/off","help":"Adds removal per vehicle.","source":"Your choice."},{"id":"removal_cost","label":"Removal per vehicle","type":"currency","default":500,"min":0,"max":5000,"step":50,"unit":"USD","help":"Wrap removal starts from $500.","source":"Pricing doc."},{"id":"years","label":"Wrap life","type":"number","default":5,"min":1,"max":10,"step":1,"unit":"years","help":"Printed wraps typically last 5 to 7 years with proper care.","source":"Assumption, informed by Ardor's stated wrap life."},{"id":"avg_job_value","label":"Average job value","type":"currency","default":2000,"min":1,"max":1000000,"step":50,"unit":"USD","help":"Your average invoice for a new customer.","source":"Assumption. Hypothetical; enter your own."},{"id":"margin","label":"Profit margin on a job","type":"percent","default":0.3,"min":0.01,"max":1,"step":0.01,"unit":"fraction","help":"Use margin after materials and direct labor, before overhead you'd pay anyway.","source":"Assumption. Hypothetical; enter your own."},{"id":"jobs_per_customer","label":"Jobs per new customer over the wrap's life","type":"number","default":1,"min":1,"max":100,"step":1,"unit":"jobs","help":"1 means no repeat business. Raise it if customers come back.","source":"Assumption."},{"id":"new_customers_per_month","label":"New customers a month you credit to the wrap","type":"number","default":1,"min":0,"max":100,"step":0.5,"unit":"customers/month","help":"Ask every new caller how they heard about you. That's the only way to know this number.","source":"Assumption. Hypothetical; track it with call tracking and a 'how did you hear about us' question."}],"outputs":[{"id":"totalCost","label":"Total wrap cost over its life","format":"currency_0"},{"id":"profitPerCustomer","label":"Profit from one new customer","format":"currency_0"},{"id":"breakEvenCustomers","label":"New customers to break even","format":"integer"},{"id":"oneEveryMonths","label":"That's one new customer every ... months","format":"decimal_1"},{"id":"paybackMonths","label":"Months to pay back at your rate","format":"decimal_1"},{"id":"profitOverLife","label":"Profit after the wrap's cost, if your estimates hold","format":"currency_0"},{"id":"grid","label":"Break-even customers by job value and margin","format":"table"}],"disclaimer":"Every profit input is hypothetical until you enter your own numbers. How many customers you credit to the wrap is your estimate, so track it: ask every caller how they found you. This calculator measures profit; the Cost per Impression calculator measures reach. Tax treatment varies; ask your accountant.","how_we_calculate":["Total cost = wrap price x vehicles + design + other upfront costs + upkeep x years, plus removal if you switch it on.","Profit per new customer = average job value x margin x jobs per customer.","Break-even customers = total cost / profit per customer, rounded up.","Payback = total cost / (new customers a month x profit per customer).","The grid reruns break-even for three job values and three margins so you can see which number matters most for your business."]}];
  /* END GENERATED */

  var MAP = {
    fleet_value: 'fleet-media-value',
    cost_per_impression: 'cost-per-impression',
    ownership_cost: 'wrap-paint-ppf',
    break_even: 'break-even-customers'
  };

  /* Formula constants. Every value here is shown in the assumptions disclosure and can be
     overridden with config_json -> constants. Defaults match roi-lab.json formula steps. */
  var CONSTANTS = {
    fleet_value: {
      baseline_miles: { value: 50, label: 'Mileage baseline for the impressions input', unit: 'miles', source: 'Formula: impressions scale with (miles per day / 50). Same 50-mile baseline as Ardor\'s existing calculator.' }
    },
    cost_per_impression: {
      sensitivity_multipliers: { value: [0.5, 1, 2], label: 'Sensitivity table: impressions-per-mile multipliers', unit: 'x', source: 'Formula: reruns your CPM at half and double the impressions per mile.' }
    },
    ownership_cost: {
      wrap_life_scenarios: { value: [3, 5, 7], label: 'Wrap-life scenarios in the sensitivity table', unit: 'years', source: 'Formula: wrap total if it lasts 3, 5 or 7 years.' }
    },
    break_even: {
      grid_margins: { value: [0.2, 0.3, 0.4], label: 'Break-even grid: margins', unit: 'fraction', source: 'Formula: grid rows.' },
      grid_job_values: { value: [1000, 2000, 5000], label: 'Break-even grid: job values', unit: 'USD', source: 'Formula: grid columns.' }
    }
  };

  /* Input grouping and output layout per calculator (presentation only). */
  var VIEW = {
    fleet_value: {
      groups: [
        { title: 'Your fleet', ids: ['vehicle_rows', 'design_cost'] },
        { title: 'Where and how much you drive', ids: ['area', 'miles_per_day', 'days_per_year', 'years'] },
        { title: 'Impressions and comparison', ids: ['base_impressions', 'comparison_cpm'] },
        { title: 'Coverage factors', ids: ['coverage_full', 'coverage_partial', 'coverage_lettering'], collapsed: true }
      ],
      hero: 'mediaValue',
      tiles: ['fleetImpressions', 'investment', 'valueToCost', 'ownCpm', 'costPerVehicleDay', 'daysToMatch'],
      extra: 'fleetBars'
    },
    cost_per_impression: {
      groups: [
        { title: 'Your wrap', ids: ['vehicles', 'wrap_price', 'design_cost', 'include_removal', 'removal_cost'] },
        { title: 'Time on the road', ids: ['years', 'days_per_year', 'miles_per_day'] },
        { title: 'Impressions and comparison', ids: ['impressions_per_mile', 'coverage', 'comparison_cpm'] }
      ],
      hero: 'cpm',
      tiles: ['totalCost', 'lifeImpressions', 'costPerDay', 'costPerMonth', 'sameReachCost', 'breakEvenPerVehicleDay'],
      extra: 'sensitivity'
    },
    ownership_cost: {
      groups: [
        { title: 'Ownership', ids: ['years', 'vehicles', 'value_per_downtime_day'] },
        { title: 'Wrap', ids: ['wrap_cost', 'wrap_life', 'rewrap', 'removal_cost', 'remove_at_end', 'downtime_days_wrap', 'adjust_wrap'] },
        { title: 'Repaint', ids: ['repaint_cost', 'paint_life', 'downtime_days_paint', 'adjust_paint'] },
        { title: 'Paint protection film (PPF)', ids: ['ppf_cost', 'ppf_life', 'downtime_days_ppf', 'adjust_ppf'] }
      ],
      hero: 'netWrap',
      tiles: [],
      extra: 'ownership'
    },
    break_even: {
      groups: [
        { title: 'Wrap cost', ids: ['vehicles', 'wrap_price', 'design_cost', 'other_upfront', 'upkeep_per_year', 'years', 'include_removal', 'removal_cost'] },
        { title: 'Your business', ids: ['avg_job_value', 'margin', 'jobs_per_customer', 'new_customers_per_month'] }
      ],
      hero: 'breakEvenCustomers',
      tiles: ['totalCost', 'profitPerCustomer', 'oneEveryMonths', 'paybackMonths', 'profitOverLife'],
      extra: 'grid'
    }
  };

  /* Inputs that only matter when a toggle is on (dimmed, never hidden). */
  var DEPENDS = {
    cost_per_impression: { removal_cost: 'include_removal' },
    break_even: { removal_cost: 'include_removal' }
  };

  var OUT_UNIT = {
    fleetImpressions: 'impressions', lifeImpressions: 'impressions', daysToMatch: 'operating days',
    oneEveryMonths: 'months', paybackMonths: 'months', breakEvenCustomers: 'customers',
    breakEvenPerVehicleDay: 'impressions', valueToCost: 'per $1 of wrap'
  };

  /* ------------------------------------------------------------- helpers */
  function isNum(x) { return typeof x === 'number' && isFinite(x); }
  function div(a, b) { return (!isNum(a) || !isNum(b) || b === 0) ? null : a / b; }
  /* Math.ceil with a 1e-9 guard so float noise (e.g. 9.000000000001) can't add a customer. */
  function ceil(x) { return Math.ceil(x - 1e-9); }
  function clone(o) { return o == null ? o : JSON.parse(JSON.stringify(o)); }
  function clamp(x, lo, hi) {
    if (isNum(lo) && x < lo) { x = lo; }
    if (isNum(hi) && x > hi) { x = hi; }
    return x;
  }
  function decimals(step) {
    if (!isNum(step)) { return 0; }
    var s = String(step);
    return s.indexOf('.') < 0 ? 0 : s.length - s.indexOf('.') - 1;
  }
  function snap(x, step, min) {
    if (!isNum(step) || step <= 0) { return x; }
    var base = isNum(min) ? min : 0;
    var v = Math.round((x - base) / step) * step + base;
    return parseFloat(v.toFixed(Math.min(6, decimals(step) + 1)));
  }

  /* --------------------------------------------------------------- model */
  function srcFor(id) {
    var key = MAP[id] || id;
    for (var i = 0; i < SRC.length; i++) { if (SRC[i].id === key) { return SRC[i]; } }
    return null;
  }

  function buildModel(id, config) {
    var src = srcFor(id);
    if (!src) { return null; }
    var inputs = clone(src.inputs).map(function (inp) {
      inp.nullable = inp['default'] === null;
      inp.srcDefault = clone(inp['default']);
      return inp;
    });
    var byId = {};
    inputs.forEach(function (inp) { byId[inp.id] = inp; });
    var constants = {};
    var cdefs = CONSTANTS[id] || {};
    Object.keys(cdefs).forEach(function (k) { constants[k] = clone(cdefs[k].value); });

    var notes = [];
    if (config && typeof config === 'object' && !Array.isArray(config)) {
      applyConfig(config, byId, constants, cdefs, notes);
    }
    return {
      id: id, src: src, inputs: inputs, byId: byId, constants: constants,
      constantDefs: cdefs, view: VIEW[id], notes: notes
    };
  }

  function coerceDefault(inp, val) {
    if (inp.type === 'rows') {
      if (!Array.isArray(val) || !val.length) { return undefined; }
      var typeField = inp.row_fields[0];
      var rows = [];
      val.slice(0, inp.max || 6).forEach(function (r) {
        if (!r || typeof r !== 'object') { return; }
        var opt = findOpt(typeField.options, r.vehicle_type);
        if (!opt) { return; }
        var count = isNum(r.count) ? Math.max(0, Math.round(r.count)) : 1;
        var price = r.price === null ? null : (isNum(r.price) ? r.price : opt.price);
        rows.push({ vehicle_type: opt.value, count: count, price: price });
      });
      return rows.length ? rows : undefined;
    }
    if (inp.type === 'toggle') { return typeof val === 'boolean' ? val : undefined; }
    if (inp.type === 'select') { var o = findOpt(inp.options, val); return o ? o.value : undefined; }
    if (val === null && inp.nullable) { return null; }
    return isNum(val) ? val : undefined;
  }

  function findOpt(options, val) {
    if (!options) { return null; }
    for (var i = 0; i < options.length; i++) {
      if (options[i].value === val || String(options[i].value) === String(val)) { return options[i]; }
    }
    return null;
  }

  function applyConfig(cfg, byId, constants, cdefs, notes) {
    var reserved = { defaults: 1, inputs: 1, options: 1, constants: 1 };
    var setDefault = function (k, v) {
      var inp = byId[k];
      if (!inp) { return; }
      var c = coerceDefault(inp, v);
      if (c !== undefined) { inp['default'] = c; notes.push(k); }
    };
    Object.keys(cfg).forEach(function (k) { if (!reserved[k]) { setDefault(k, cfg[k]); } });
    if (cfg.defaults && typeof cfg.defaults === 'object') {
      Object.keys(cfg.defaults).forEach(function (k) { setDefault(k, cfg.defaults[k]); });
    }
    if (cfg.inputs && typeof cfg.inputs === 'object') {
      Object.keys(cfg.inputs).forEach(function (k) {
        var inp = byId[k], o = cfg.inputs[k];
        if (!inp || !o || typeof o !== 'object') { return; }
        ['label', 'help', 'source', 'unit'].forEach(function (p) { if (typeof o[p] === 'string') { inp[p] = o[p]; } });
        ['min', 'max', 'step'].forEach(function (p) { if (isNum(o[p])) { inp[p] = o[p]; } });
        if ('default' in o) { setDefault(k, o['default']); }
      });
    }
    if (cfg.options && typeof cfg.options === 'object') {
      Object.keys(cfg.options).forEach(function (k) {
        var inp = byId[k];
        var opts = null;
        if (inp && inp.options) { opts = inp.options; }
        if (!opts) {
          /* row field (vehicle_type) */
          Object.keys(byId).forEach(function (id) {
            var i2 = byId[id];
            if (i2.row_fields) { i2.row_fields.forEach(function (f) { if (f.id === k && f.options) { opts = f.options; } }); }
          });
        }
        if (!opts || typeof cfg.options[k] !== 'object') { return; }
        Object.keys(cfg.options[k]).forEach(function (ov) {
          var opt = findOpt(opts, ov), patch = cfg.options[k][ov];
          if (!opt || !patch || typeof patch !== 'object') { return; }
          ['label', 'source', 'coverage'].forEach(function (p) { if (typeof patch[p] === 'string') { opt[p] = patch[p]; } });
          ['factor'].forEach(function (p) { if (isNum(patch[p])) { opt[p] = patch[p]; } });
          if (isNum(patch.price) || patch.price === null) { opt.price = patch.price; }
          notes.push(k + ':' + ov);
        });
      });
      /* keep row defaults priced from the (possibly updated) option list */
      Object.keys(byId).forEach(function (id) {
        var inp = byId[id];
        if (inp.type === 'rows' && Array.isArray(inp['default']) && !(cfg.defaults && cfg.defaults[id]) && !cfg[id]) {
          inp['default'] = inp['default'].map(function (r) {
            var opt = findOpt(inp.row_fields[0].options, r.vehicle_type);
            return { vehicle_type: r.vehicle_type, count: r.count, price: opt ? opt.price : r.price };
          });
        }
      });
    }
    if (cfg.constants && typeof cfg.constants === 'object') {
      Object.keys(cfg.constants).forEach(function (k) {
        if (!(k in cdefs)) { return; }
        var v = cfg.constants[k], d = cdefs[k].value;
        if (Array.isArray(d)) {
          if (Array.isArray(v) && v.length && v.every(isNum)) { constants[k] = v.slice(0, 6); notes.push(k); }
        } else if (isNum(v) && v > 0) { constants[k] = v; notes.push(k); }
      });
    }
  }

  function defaultsFor(model) {
    var v = {};
    model.inputs.forEach(function (inp) { v[inp.id] = clone(inp['default']); });
    return v;
  }

  /* Lookup tables derived from select options (fleet calculator). */
  function tables(model) {
    var t = {};
    var rows = model.byId.vehicle_rows;
    if (rows) {
      t.TYPES = {};
      rows.row_fields[0].options.forEach(function (o) { t.TYPES[o.value] = o; });
    }
    var area = model.byId.area;
    if (area) {
      t.AREA = {};
      area.options.forEach(function (o) { t.AREA[o.value] = o; });
    }
    return t;
  }

  /* ------------------------------------------------------------ formulas */
  /* Each formula mirrors the "formula.steps" in roi-lab.json line by line. */
  var COMPUTE = {
    fleet_value: function (v, K) {
      var rows = v.vehicle_rows || [];
      var TYPES = K.TYPES, AREA = K.AREA;
      var cov = { full: v.coverage_full, partial: v.coverage_partial, lettering: v.coverage_lettering };
      var areaFactor = AREA[v.area] ? AREA[v.area].factor : 1;
      var impPerVehDay = function (row) {
        var t = TYPES[row.vehicle_type];
        return v.base_impressions * areaFactor * (v.miles_per_day / K.baseline_miles) * cov[t ? t.coverage : 'full'];
      };
      var vehicles = rows.reduce(function (s, r) { return s + r.count; }, 0);
      var fleetImpressions = rows.reduce(function (s, r) { return s + r.count * impPerVehDay(r); }, 0) * v.days_per_year * v.years;
      var missingPrice = rows.some(function (r) { return !isNum(r.price); });
      var investment = missingPrice ? null : rows.reduce(function (s, r) { return s + r.count * r.price; }, 0) + v.design_cost;
      var mediaValue = (fleetImpressions / 1000) * v.comparison_cpm;
      var valueToCost = div(mediaValue, investment);
      var ownCpm = div(investment, fleetImpressions / 1000);
      var costPerVehicleDay = div(investment, vehicles * v.days_per_year * v.years);
      var daysToMatch = div(investment, div(mediaValue, v.days_per_year * v.years));
      var prompts = {};
      if (missingPrice) {
        ['investment', 'valueToCost', 'ownCpm', 'costPerVehicleDay', 'daysToMatch'].forEach(function (k) { prompts[k] = 'Enter your quote'; });
      }
      return {
        fleetImpressions: fleetImpressions, investment: investment, mediaValue: mediaValue,
        valueToCost: valueToCost, ownCpm: ownCpm, costPerVehicleDay: costPerVehicleDay,
        daysToMatch: daysToMatch, vehicles: vehicles, areaFactor: areaFactor, _prompts: prompts
      };
    },

    cost_per_impression: function (v, K) {
      var totalCost = v.vehicles * v.wrap_price + v.design_cost + (v.include_removal ? v.vehicles * v.removal_cost : 0);
      var imprPerDay = v.miles_per_day * v.impressions_per_mile * v.coverage;
      var lifeDays = v.years * v.days_per_year;
      var lifeImpressions = v.vehicles * imprPerDay * lifeDays;
      var cpm = div(totalCost, lifeImpressions / 1000);
      var costPerDay = div(totalCost, v.vehicles * lifeDays);
      var costPerMonth = div(totalCost, v.vehicles * v.years * 12);
      var sameReachCost = (lifeImpressions / 1000) * v.comparison_cpm;
      var breakEvenImpressions = v.comparison_cpm ? (totalCost / v.comparison_cpm) * 1000 : null;
      var breakEvenPerVehicleDay = div(breakEvenImpressions, v.vehicles * lifeDays);
      var sensitivity = K.sensitivity_multipliers.map(function (m) {
        return { multiplier: m, impressionsPerMile: v.impressions_per_mile * m, cpm: div(totalCost, (lifeImpressions * m) / 1000) };
      });
      return {
        totalCost: totalCost, lifeImpressions: lifeImpressions, cpm: cpm, costPerDay: costPerDay,
        costPerMonth: costPerMonth, sameReachCost: sameReachCost, breakEvenImpressions: breakEvenImpressions,
        breakEvenPerVehicleDay: breakEvenPerVehicleDay, sensitivity: sensitivity, imprPerDay: imprPerDay, _prompts: {}
      };
    },

    ownership_cost: function (v, K) {
      var wrapCycles = v.rewrap ? ceil(v.years / v.wrap_life) : 1;
      var wrapRemovals = (wrapCycles - 1) + (v.remove_at_end ? 1 : 0);
      var totalWrap = v.vehicles * (wrapCycles * v.wrap_cost + wrapRemovals * v.removal_cost);
      var totalPaint = v.repaint_cost == null ? null : v.vehicles * ceil(v.years / v.paint_life) * v.repaint_cost;
      var totalPpf = v.ppf_cost == null ? null : v.vehicles * ceil(v.years / v.ppf_life) * v.ppf_cost;
      var net = function (total, days, adj) { return total == null ? null : total + v.vehicles * (days || 0) * v.value_per_downtime_day - adj; };
      var netWrap = net(totalWrap, v.downtime_days_wrap, v.adjust_wrap);
      var netPaint = net(totalPaint, v.downtime_days_paint, v.adjust_paint);
      var netPpf = net(totalPpf, v.downtime_days_ppf, v.adjust_ppf);
      var perYear = function (n) { return n == null ? null : n / v.years; };
      var perMonth = function (n) { return n == null ? null : n / (v.years * 12); };
      var wrapLifeSensitivity = K.wrap_life_scenarios.map(function (L) {
        var c = v.rewrap ? ceil(v.years / L) : 1;
        var r = (c - 1) + (v.remove_at_end ? 1 : 0);
        return { wrapLife: L, total: v.vehicles * (c * v.wrap_cost + r * v.removal_cost) };
      });
      var prompts = {};
      if (netPaint == null) { prompts.netPaint = 'Add a quote'; }
      if (netPpf == null) { prompts.netPpf = 'Add a quote'; }
      return {
        netWrap: netWrap, netPaint: netPaint, netPpf: netPpf,
        perYear: { wrap: perYear(netWrap), paint: perYear(netPaint), ppf: perYear(netPpf) },
        perMonth: { wrap: perMonth(netWrap), paint: perMonth(netPaint), ppf: perMonth(netPpf) },
        wrapLifeSensitivity: wrapLifeSensitivity, wrapCycles: wrapCycles, wrapRemovals: wrapRemovals,
        totalWrap: totalWrap, totalPaint: totalPaint, totalPpf: totalPpf, _prompts: prompts
      };
    },

    break_even: function (v, K) {
      var totalCost = v.vehicles * (v.wrap_price + (v.include_removal ? v.removal_cost : 0)) + v.design_cost + v.other_upfront + v.upkeep_per_year * v.years;
      var profitPerCustomer = v.avg_job_value * v.margin * v.jobs_per_customer;
      var breakEvenCustomers = profitPerCustomer > 0 ? ceil(totalCost / profitPerCustomer) : null;
      var oneEveryMonths = div(v.years * 12, breakEvenCustomers);
      var paybackMonths = v.new_customers_per_month > 0 ? totalCost / (v.new_customers_per_month * profitPerCustomer) : null;
      var profitOverLife = v.new_customers_per_month > 0 ? v.new_customers_per_month * v.years * 12 * profitPerCustomer - totalCost : null;
      var grid = K.grid_margins.map(function (m) {
        return K.grid_job_values.map(function (val) { return ceil(totalCost / (val * m * v.jobs_per_customer)); });
      });
      var prompts = {};
      if (!(v.new_customers_per_month > 0)) {
        prompts.paybackMonths = 'Enter how many customers you credit to the wrap';
        prompts.profitOverLife = 'Enter how many customers you credit to the wrap';
      }
      return {
        totalCost: totalCost, profitPerCustomer: profitPerCustomer, breakEvenCustomers: breakEvenCustomers,
        oneEveryMonths: oneEveryMonths, paybackMonths: paybackMonths, profitOverLife: profitOverLife,
        grid: grid, _prompts: prompts
      };
    }
  };

  function compute(model, values) {
    var K = tables(model);
    Object.keys(model.constants).forEach(function (k) { K[k] = model.constants[k]; });
    return COMPUTE[model.id](values, K);
  }

  /* ---------------------------------------------------------- formatting */
  var NF = {};
  function nf(key, opts) {
    if (!NF[key]) {
      try { NF[key] = new Intl.NumberFormat('en-US', opts); } catch (e) { NF[key] = new Intl.NumberFormat('en-US'); }
    }
    return NF[key];
  }
  var DASH = '–';
  function fmt(v, format) {
    if (!isNum(v)) { return DASH; }
    if (Math.abs(v) < 0.005) { v = 0; }
    switch (format) {
      case 'currency_0':
      case 'currency_0_or_prompt':
        return nf('c0', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(v);
      case 'currency_2':
      case 'ratio_2':
        return nf('c2', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(v);
      case 'integer':
        return nf('i0', { maximumFractionDigits: 0 }).format(Math.round(v));
      case 'integer_compact':
        return nf('ic', { notation: 'compact', compactDisplay: 'short', maximumFractionDigits: 1 }).format(v);
      case 'decimal_1':
        return nf('d1', { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(v);
      case 'percent_0':
        return nf('p0', { style: 'percent', maximumFractionDigits: 0 }).format(v);
      case 'number':
        return nf('n', { maximumFractionDigits: 2 }).format(v);
      default:
        return nf('n', { maximumFractionDigits: 2 }).format(v);
    }
  }
  function fmtInput(inp, v) {
    if (v == null || v === '') { return 'Not set'; }
    if (inp.type === 'currency') { return fmt(v, Math.round(v) === v ? 'currency_0' : 'currency_2') + unitSuffix(inp, true); }
    if (inp.type === 'percent') { return fmt(v, 'percent_0'); }
    if (inp.type === 'toggle') { return v ? 'On' : 'Off'; }
    if (inp.type === 'select') { var o = findOpt(inp.options, v); return o ? o.label : String(v); }
    if (inp.type === 'rows') { return Array.isArray(v) ? v.length + (v.length === 1 ? ' row' : ' rows') : ''; }
    var u = inp.unit || '';
    if (u === 'factor' || u === 'multiplier') { return fmt(v, 'number') + 'x'; }
    if (v === 1) { u = u.replace(/^(\w+)s(\/|$)/, '$1$2'); }
    return fmt(v, 'number') + (u ? ' ' + u : '');
  }
  function unitSuffix(inp, forText) {
    var u = inp.unit || '';
    var map = {
      'USD/day': '/day', 'USD/year': '/year', 'USD per 1,000 impressions': ' per 1,000',
      'impressions/day': '/day', 'impressions/mile': '/mile', 'customers/month': '/mo',
      'days/year': 'days/yr', 'factor': 'x', 'multiplier': 'x', 'fraction': '%'
    };
    if (forText) { return /^USD/.test(u) && map[u] ? map[u] : ''; }
    if (map[u]) { return map[u]; }
    if (u === 'USD' || u === 'on/off' || u === 'rows') { return ''; }
    return u;
  }

  /* ----------------------------------------------------------------- DOM */
  var uid = 0;
  function h(tag, attrs, kids) {
    var el = document.createElement(tag);
    if (attrs) {
      Object.keys(attrs).forEach(function (k) {
        var v = attrs[k];
        if (v == null || v === false) { return; }
        if (k === 'class') { el.className = v; }
        else if (k === 'text') { el.textContent = v; }
        else if (k.slice(0, 2) === 'on' && typeof v === 'function') { el.addEventListener(k.slice(2), v); }
        else { el.setAttribute(k, v === true ? '' : v); }
      });
    }
    (kids || []).forEach(function (c) {
      if (c == null || c === false) { return; }
      el.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
    });
    return el;
  }
  function svg(path, size) {
    var ns = 'http://www.w3.org/2000/svg';
    var s = document.createElementNS(ns, 'svg');
    s.setAttribute('viewBox', '0 0 24 24');
    s.setAttribute('width', size || 16);
    s.setAttribute('height', size || 16);
    s.setAttribute('aria-hidden', 'true');
    s.setAttribute('focusable', 'false');
    s.setAttribute('fill', 'none');
    s.setAttribute('stroke', 'currentColor');
    s.setAttribute('stroke-width', '2');
    s.setAttribute('stroke-linecap', 'round');
    s.setAttribute('stroke-linejoin', 'round');
    var p = document.createElementNS(ns, 'path');
    p.setAttribute('d', path);
    s.appendChild(p);
    return s;
  }
  var ICON = {
    plus: 'M12 5v14M5 12h14', minus: 'M5 12h14', close: 'M6 6l12 12M18 6 6 18',
    reset: 'M3 12a9 9 0 1 0 3-6.7M3 4v5h5', down: 'M12 5v14M6 13l6 6 6-6', info: 'M12 8h.01M11 12h1v5h1'
  };
  function reducedMotion() {
    try {
      return root.matchMedia('(prefers-reduced-motion: reduce)').matches || document.documentElement.getAttribute('data-shift') === 'off';
    } catch (e) { return false; }
  }

  /* Range <-> value mapping. Wide ranges use a log/power curve so everyday values stay reachable. */
  function rangeMode(inp) {
    if (!isNum(inp.min) || !isNum(inp.max) || !isNum(inp.step) || inp.step <= 0) { return 'linear'; }
    var steps = (inp.max - inp.min) / inp.step;
    if (steps <= 4000) { return 'linear'; }
    return inp.min > 0 ? 'log' : 'pow';
  }
  function toPos(inp, mode, v) {
    if (!isNum(v)) { return 0; }
    var t;
    if (mode === 'log') { t = Math.log(clamp(v, inp.min, inp.max) / inp.min) / Math.log(inp.max / inp.min); }
    else { t = Math.pow((clamp(v, inp.min, inp.max) - inp.min) / (inp.max - inp.min), 1 / 3); }
    return Math.round(t * 1000);
  }
  function fromPos(inp, mode, pos) {
    var t = pos / 1000, v;
    if (mode === 'log') { v = inp.min * Math.pow(inp.max / inp.min, t); }
    else { v = inp.min + (inp.max - inp.min) * Math.pow(t, 3); }
    var mag = Math.max(inp.step, Math.pow(10, Math.floor(Math.log(Math.max(Math.abs(v), 1)) / Math.LN10) - 1));
    var stepped = Math.max(inp.step, Math.round(mag / inp.step) * inp.step);
    return clamp(snap(v, stepped, 0), inp.min, inp.max);
  }

  /* --------------------------------------------------------------- Calc */
  function Calc(mount) {
    this.mount = mount;
    this.id = mount.getAttribute('data-cwv-calc');
    this.section = mount.closest('[data-cwv-calc-section]') || mount.parentNode;
    this.uid = 'cc' + (++uid) + '-' + (mount.getAttribute('data-section-id') || '').replace(/[^\w-]/g, '').slice(-24);
    var cfg = null, cfgEl = this.section.querySelector('[data-cwv-calc-config]');
    if (cfgEl) {
      var raw = (cfgEl.textContent || '').trim();
      if (raw) {
        try { cfg = JSON.parse(raw); } catch (e) {
          if (root.console) { root.console.warn('[CWV calculator] config_json is not valid JSON and was ignored.', e); }
        }
      }
    }
    this.model = buildModel(this.id, cfg);
    if (!this.model) {
      mount.innerHTML = '';
      mount.appendChild(h('p', { class: 'calc-noscript', text: 'Unknown calculator "' + this.id + '". Pick one in the section settings.' }));
      return;
    }
    this.values = defaultsFor(this.model);
    this.fields = {};
    this.out = {};
    this.heroShown = null;
    this.render();
    this.syncAll();
    this.update(true);
  }

  Calc.prototype.render = function () {
    var self = this, m = this.model, view = m.view;
    var mount = this.mount;
    var skel = mount.querySelector('.calc-skeleton');
    if (skel) { skel.parentNode.removeChild(skel); }
    /* server-rendered default results (snippets/cwv-calc-defaults.liquid) give way to the live calculator */
    var ssr = mount.querySelector('[data-calc-ssr]');
    if (ssr) { ssr.parentNode.removeChild(ssr); }

    var inputsCol = h('div', { class: 'calc-inputs' });
    var gi = 0;
    view.groups.forEach(function (g) {
      var fieldsWrap = h('div', { class: 'calc-fields' });
      g.ids.forEach(function (id) {
        var inp = m.byId[id];
        if (inp) { fieldsWrap.appendChild(self.field(inp)); }
      });
      gi++;
      var num = (gi < 10 ? '0' : '') + gi;
      if (g.collapsed) {
        var det = h('details', { class: 'calc-group calc-group--more' }, [
          h('summary', { class: 'calc-group-sum' }, [
            h('span', { class: 'calc-group-k' }, [h('span', { class: 'calc-group-n', text: num }), g.title]),
            h('span', { class: 'calc-group-hint', text: 'Assumptions · edit' })
          ]),
          fieldsWrap
        ]);
        inputsCol.appendChild(det);
      } else {
        inputsCol.appendChild(h('fieldset', { class: 'calc-group' }, [
          h('legend', { class: 'calc-group-k' }, [h('span', { class: 'calc-group-n', text: num }), g.title]),
          fieldsWrap
        ]));
      }
    });
    /* any input not placed in a group still renders (keeps every roi-lab input on screen) */
    var placed = {};
    view.groups.forEach(function (g) { g.ids.forEach(function (id) { placed[id] = 1; }); });
    var rest = m.inputs.filter(function (i) { return !placed[i.id]; });
    if (rest.length) {
      var fw = h('div', { class: 'calc-fields' });
      rest.forEach(function (inp) { fw.appendChild(self.field(inp)); });
      inputsCol.appendChild(h('fieldset', { class: 'calc-group' }, [h('legend', { class: 'calc-group-k', text: 'More inputs' }), fw]));
    }

    /* mini sticky readout for phones */
    var heroDef = this.outDef(view.hero);
    this.mini = h('div', { class: 'calc-mini', 'aria-hidden': 'true' }, [
      h('span', { class: 'calc-mini-k', text: heroDef ? heroDef.label : 'Result' }),
      h('span', { class: 'calc-mini-v', text: DASH })
    ]);
    var resultsId = this.uid + '-results';
    var miniBtn = h('a', { class: 'calc-mini-go', href: '#' + resultsId, tabindex: '-1' }, ['Results', svg(ICON.down, 14)]);
    this.mini.appendChild(miniBtn);
    inputsCol.appendChild(this.mini);

    /* outputs */
    var outCol = h('div', { class: 'calc-out', id: resultsId, role: 'region', 'aria-label': 'Results' });
    var panel = h('div', { class: 'calc-out-panel' });
    outCol.appendChild(panel);
    panel.appendChild(h('div', { class: 'calc-out-top' }, [
      h('p', { class: 'calc-out-k', text: 'Output · ' + (heroDef ? heroDef.label : '') }),
      h('span', { class: 'calc-live', 'aria-hidden': 'true' }, [h('span', { class: 'calc-live-dot' }), 'Live'])
    ]));
    this.heroV = h('span', { class: 'calc-hero-v' });
    this.heroU = h('span', { class: 'calc-hero-u' });
    this.heroSub = h('p', { class: 'calc-hero-sub' });
    panel.appendChild(h('p', { class: 'calc-hero' }, [this.heroV, this.heroU]));
    panel.appendChild(this.heroSub);

    if (view.tiles.length) {
      var dl = h('dl', { class: 'calc-tiles' });
      view.tiles.forEach(function (oid) {
        var def = self.outDef(oid);
        if (!def) { return; }
        var v = h('span', { class: 'calc-tile-v' });
        var u = h('span', { class: 'calc-tile-u' });
        var sub = h('span', { class: 'calc-tile-sub' });
        dl.appendChild(h('div', { class: 'calc-tile', 'data-out': oid }, [
          h('dt', { class: 'calc-tile-k', text: def.label }),
          h('dd', { class: 'calc-tile-d' }, [v, u, sub])
        ]));
        self.out[oid] = { v: v, u: u, sub: sub, def: def };
      });
      panel.appendChild(dl);
    }
    this.extra = h('div', { class: 'calc-extra' });
    panel.appendChild(this.extra);

    var actions = h('div', { class: 'calc-actions' });
    var cta = this.section.querySelector('[data-calc-cta]');
    if (cta) { actions.appendChild(cta); }
    var reset = h('button', { type: 'button', class: 'calc-reset', onclick: function () { self.reset(); } }, [svg(ICON.reset, 14), 'Reset to defaults']);
    actions.appendChild(reset);
    panel.appendChild(actions);

    this.live = h('p', { class: 'cwv-sr-only calc-sr', 'aria-live': 'polite' });

    var ui = h('div', { class: 'calc-ui' }, [inputsCol, outCol]);
    mount.appendChild(ui);
    mount.appendChild(this.assumptions());
    mount.appendChild(this.live);

    miniBtn.addEventListener('click', function (e) {
      e.preventDefault();
      outCol.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'start' });
    });

    mount.classList.add('is-ready');
    this.section.classList.add('is-ready');
  };

  Calc.prototype.outDef = function (oid) {
    var outs = this.model.src.outputs;
    for (var i = 0; i < outs.length; i++) { if (outs[i].id === oid) { return outs[i]; } }
    return null;
  };

  /* ---------------------------------------------------------- fields */
  Calc.prototype.field = function (inp) {
    if (inp.type === 'rows') { return this.rowsField(inp); }
    if (inp.type === 'toggle') { return this.toggleField(inp); }
    if (inp.type === 'select') { return this.selectField(inp); }
    return this.numberField(inp);
  };

  Calc.prototype.meta = function (inp, wrap, describedIds) {
    var id = this.uid + '-' + inp.id;
    if (inp.help) {
      wrap.appendChild(h('p', { class: 'ci-help', id: id + '-help', text: inp.help }));
      describedIds.push(id + '-help');
    }
    if (inp.source) {
      wrap.appendChild(h('p', { class: 'ci-src', id: id + '-src' }, [h('span', { class: 'ci-src-k', text: 'Source' }), inp.source]));
      describedIds.push(id + '-src');
    }
  };

  Calc.prototype.numberField = function (inp) {
    var self = this;
    var id = this.uid + '-' + inp.id;
    var isPct = inp.type === 'percent';
    var scale = isPct ? 100 : 1;
    var wrap = h('div', { class: 'ci ci--num' + (inp.nullable ? ' ci--nullable' : ''), 'data-ci': inp.id });
    var unitTxt = isPct ? '%' : (inp.unit && inp.unit !== 'USD' ? inp.unit : (inp.type === 'currency' ? 'USD' : ''));
    wrap.appendChild(h('div', { class: 'ci-top' }, [
      h('label', { class: 'ci-label', for: id, text: inp.label }),
      unitTxt ? h('span', { class: 'ci-unit', text: unitTxt }) : null
    ]));
    var numAttrs = {
      type: 'number', id: id, class: 'ci-input', inputmode: 'decimal',
      min: isNum(inp.min) ? inp.min * scale : null,
      max: isNum(inp.max) ? inp.max * scale : null,
      step: isNum(inp.step) ? parseFloat((inp.step * scale).toFixed(6)) : 'any',
      placeholder: inp.nullable ? (inp.type === 'currency' ? 'Add a quote' : 'Your input') : null
    };
    var num = h('input', numAttrs);
    var mode = rangeMode(inp);
    var rng = null;
    if (isNum(inp.min) && isNum(inp.max)) {
      rng = h('input', {
        type: 'range', class: 'ci-range', id: id + '-range', 'aria-label': inp.label + ' (slider)',
        min: mode === 'linear' ? inp.min * scale : 0,
        max: mode === 'linear' ? inp.max * scale : 1000,
        step: mode === 'linear' ? (isNum(inp.step) ? parseFloat((inp.step * scale).toFixed(6)) : 'any') : 1
      });
    }
    var pre = inp.type === 'currency' ? h('span', { class: 'ci-pre', 'aria-hidden': 'true', text: '$' }) : null;
    var suf = unitSuffix(inp);
    var sufEl = suf ? h('span', { class: 'ci-suf', 'aria-hidden': 'true', text: suf }) : null;
    var clearBtn = null;
    if (inp.nullable) {
      clearBtn = h('button', { type: 'button', class: 'ci-clear', 'aria-label': 'Clear ' + inp.label, hidden: true }, [svg(ICON.close, 12)]);
    }
    var box = h('div', { class: 'ci-num' + (pre ? ' has-pre' : '') }, [pre, num, sufEl, clearBtn]);
    wrap.appendChild(h('div', { class: 'ci-ctrl' }, [box, rng]));
    var described = [];
    this.meta(inp, wrap, described);
    if (described.length) { num.setAttribute('aria-describedby', described.join(' ')); }

    var f = { inp: inp, wrap: wrap, num: num, rng: rng, mode: mode, scale: scale, clear: clearBtn };
    this.fields[inp.id] = f;

    num.addEventListener('input', function () {
      var raw = num.value.trim();
      if (raw === '') {
        if (inp.nullable) { self.set(inp.id, null, 'num'); }
        return;
      }
      var x = parseFloat(raw);
      if (!isNum(x)) { return; }
      self.set(inp.id, clamp(x / scale, inp.min, inp.max), 'num');
    });
    num.addEventListener('change', function () { self.sync(inp.id); });
    num.addEventListener('blur', function () { self.sync(inp.id); });
    if (rng) {
      rng.addEventListener('input', function () {
        var p = parseFloat(rng.value);
        var v = mode === 'linear' ? p / scale : fromPos(inp, mode, p);
        if (mode === 'linear') { v = clamp(snap(v, inp.step, inp.min), inp.min, inp.max); }
        self.set(inp.id, v, 'rng');
      });
    }
    if (clearBtn) {
      clearBtn.addEventListener('click', function () { self.set(inp.id, null); self.sync(inp.id); num.focus(); });
    }
    return wrap;
  };

  Calc.prototype.toggleField = function (inp) {
    var self = this, id = this.uid + '-' + inp.id;
    var wrap = h('div', { class: 'ci ci--toggle', 'data-ci': inp.id });
    var cb = h('input', { type: 'checkbox', role: 'switch', id: id, class: 'ci-switch-input' });
    wrap.appendChild(h('div', { class: 'ci-toggle-row' }, [
      h('label', { class: 'ci-switch', for: id }, [cb, h('span', { class: 'ci-switch-ui', 'aria-hidden': 'true' }), h('span', { class: 'ci-label', text: inp.label })])
    ]));
    var described = [];
    this.meta(inp, wrap, described);
    if (described.length) { cb.setAttribute('aria-describedby', described.join(' ')); }
    this.fields[inp.id] = { inp: inp, wrap: wrap, cb: cb };
    cb.addEventListener('change', function () { self.set(inp.id, cb.checked); });
    return wrap;
  };

  Calc.prototype.selectField = function (inp) {
    var self = this, id = this.uid + '-' + inp.id;
    var short = inp.options.length <= 4 && inp.options.every(function (o) { return String(o.label).length <= 22; });
    var wrap, f = { inp: inp };
    var described = [];
    if (short) {
      wrap = h('fieldset', { class: 'ci ci--seg', 'data-ci': inp.id });
      wrap.appendChild(h('legend', { class: 'ci-label', text: inp.label }));
      var seg = h('div', { class: 'ci-seg' });
      f.radios = [];
      inp.options.forEach(function (o, i) {
        var r = h('input', { type: 'radio', name: id, id: id + '-' + i, value: String(i), class: 'ci-seg-input' });
        r.addEventListener('change', function () { if (r.checked) { self.set(inp.id, inp.options[i].value); } });
        f.radios.push(r);
        var extra = isNum(o.factor) ? h('span', { class: 'ci-seg-x', text: 'x' + o.factor }) : null;
        seg.appendChild(h('label', { class: 'ci-seg-opt', for: id + '-' + i }, [r, h('span', { class: 'ci-seg-ui' }, [o.label, extra])]));
      });
      wrap.appendChild(seg);
      this.meta(inp, wrap, described);
      if (described.length) { seg.setAttribute('aria-describedby', described.join(' ')); }
    } else {
      wrap = h('div', { class: 'ci ci--select', 'data-ci': inp.id });
      wrap.appendChild(h('div', { class: 'ci-top' }, [h('label', { class: 'ci-label', for: id, text: inp.label })]));
      var sel = h('select', { id: id, class: 'ci-select' });
      inp.options.forEach(function (o, i) { sel.appendChild(h('option', { value: String(i), text: o.label })); });
      sel.addEventListener('change', function () { self.set(inp.id, inp.options[parseInt(sel.value, 10)].value); });
      wrap.appendChild(h('div', { class: 'ci-select-wrap' }, [sel]));
      f.sel = sel;
      this.meta(inp, wrap, described);
      if (described.length) { sel.setAttribute('aria-describedby', described.join(' ')); }
    }
    f.wrap = wrap;
    this.fields[inp.id] = f;
    return wrap;
  };

  Calc.prototype.rowsField = function (inp) {
    var self = this, id = this.uid + '-' + inp.id;
    var wrap = h('div', { class: 'ci ci--rows', 'data-ci': inp.id, role: 'group', 'aria-labelledby': id + '-lbl' });
    wrap.appendChild(h('div', { class: 'ci-top' }, [
      h('span', { class: 'ci-label', id: id + '-lbl', text: inp.label }),
      h('span', { class: 'ci-unit', text: 'up to ' + (inp.max || 6) + ' ' + (inp.unit || 'rows') })
    ]));
    var list = h('ol', { class: 'cr-list' });
    wrap.appendChild(list);
    var add = h('button', { type: 'button', class: 'cr-add' }, [svg(ICON.plus, 14), 'Add a vehicle row']);
    wrap.appendChild(add);
    var described = [];
    this.meta(inp, wrap, described);
    this.fields[inp.id] = { inp: inp, wrap: wrap, list: list, add: add };
    add.addEventListener('click', function () {
      var rows = self.values[inp.id];
      if (rows.length >= (inp.max || 6)) { return; }
      var typeF = inp.row_fields[0];
      var opt = findOpt(typeF.options, typeF['default']) || typeF.options[0];
      rows.push({ vehicle_type: opt.value, count: 1, price: opt.price });
      self.renderRows(inp.id);
      self.update();
      var sels = list.querySelectorAll('select');
      if (sels.length) { sels[sels.length - 1].focus(); }
    });
    return wrap;
  };

  Calc.prototype.renderRows = function (key) {
    var self = this, f = this.fields[key], inp = f.inp;
    var rows = this.values[key];
    var typeF = inp.row_fields[0], countF = inp.row_fields[1], priceF = inp.row_fields[2];
    f.list.innerHTML = '';
    rows.forEach(function (row, ri) {
      var rid = self.uid + '-' + key + '-' + ri;
      var sel = h('select', { id: rid + '-t', class: 'ci-select' });
      typeF.options.forEach(function (o, i) {
        var opt = h('option', { value: String(i), text: o.label });
        if (o.value === row.vehicle_type) { opt.selected = true; }
        sel.appendChild(opt);
      });
      var cnt = h('input', { type: 'number', id: rid + '-c', class: 'ci-input', inputmode: 'numeric', min: countF.min, max: countF.max, step: countF.step, value: String(row.count) });
      var price = h('input', { type: 'number', id: rid + '-p', class: 'ci-input', inputmode: 'decimal', min: priceF.min, max: priceF.max, step: priceF.step, value: isNum(row.price) ? String(row.price) : '', placeholder: 'Your quote', 'aria-describedby': rid + '-src' });
      var minus = h('button', { type: 'button', class: 'cr-step', 'aria-label': 'One fewer, row ' + (ri + 1) }, [svg(ICON.minus, 14)]);
      var plus = h('button', { type: 'button', class: 'cr-step', 'aria-label': 'One more, row ' + (ri + 1) }, [svg(ICON.plus, 14)]);
      var del = rows.length > (inp.min || 1) ? h('button', { type: 'button', class: 'cr-del', 'aria-label': 'Remove row ' + (ri + 1) }, [svg(ICON.close, 14)]) : null;
      var opt0 = findOpt(typeF.options, row.vehicle_type);
      var src = h('p', { class: 'ci-src cr-src', id: rid + '-src' }, [h('span', { class: 'ci-src-k', text: 'Source' }), opt0 && opt0.source ? opt0.source : '']);
      var li = h('li', { class: 'cr-row' + (isNum(row.price) ? '' : ' is-missing') }, [
        h('span', { class: 'cr-idx', 'aria-hidden': 'true', text: (ri < 9 ? '0' : '') + (ri + 1) }),
        h('div', { class: 'cr-f cr-type' }, [h('label', { class: 'cr-k', for: rid + '-t', text: typeF.label }), h('div', { class: 'ci-select-wrap' }, [sel])]),
        h('div', { class: 'cr-f cr-count' }, [h('label', { class: 'cr-k', for: rid + '-c', text: countF.label }), h('div', { class: 'ci-num ci-num--step' }, [minus, cnt, plus])]),
        h('div', { class: 'cr-f cr-price' }, [h('label', { class: 'cr-k', for: rid + '-p', text: priceF.label }), h('div', { class: 'ci-num has-pre' }, [h('span', { class: 'ci-pre', 'aria-hidden': 'true', text: '$' }), price])]),
        del,
        src
      ]);
      f.list.appendChild(li);

      sel.addEventListener('change', function () {
        var o = typeF.options[parseInt(sel.value, 10)];
        row.vehicle_type = o.value;
        row.price = o.price;
        price.value = isNum(o.price) ? String(o.price) : '';
        src.lastChild.textContent = o.source || '';
        li.classList.toggle('is-missing', !isNum(row.price));
        self.update();
        if (!isNum(o.price)) { price.focus(); }
      });
      var setCount = function (x) {
        row.count = Math.round(clamp(x, countF.min, countF.max));
        self.update();
      };
      cnt.addEventListener('input', function () { var x = parseFloat(cnt.value); if (isNum(x)) { setCount(x); } });
      cnt.addEventListener('change', function () { cnt.value = String(row.count); });
      minus.addEventListener('click', function () { setCount(row.count - 1); cnt.value = String(row.count); });
      plus.addEventListener('click', function () { setCount(row.count + 1); cnt.value = String(row.count); });
      price.addEventListener('input', function () {
        var raw = price.value.trim();
        if (raw === '') { row.price = null; }
        else { var x = parseFloat(raw); if (!isNum(x)) { return; } row.price = clamp(x, priceF.min, priceF.max); }
        li.classList.toggle('is-missing', !isNum(row.price));
        self.update();
      });
      price.addEventListener('change', function () { price.value = isNum(row.price) ? String(row.price) : ''; });
      if (del) {
        del.addEventListener('click', function () {
          rows.splice(ri, 1);
          self.renderRows(key);
          self.update();
          var btn = f.list.querySelector('select');
          if (btn) { btn.focus(); }
        });
      }
    });
    f.add.disabled = rows.length >= (inp.max || 6);
  };

  /* ------------------------------------------------------- state & sync */
  Calc.prototype.set = function (key, val, from) {
    this.values[key] = val;
    this.sync(key, from);
    this.update();
  };

  /* write the model value back to the controls; `from` skips the control being typed in */
  Calc.prototype.sync = function (key, from) {
    var f = this.fields[key];
    if (!f) { return; }
    var inp = f.inp, v = this.values[key];
    if (inp.type === 'rows') { this.renderRows(key); return; }
    if (f.cb) { f.cb.checked = !!v; return; }
    if (f.radios) {
      f.radios.forEach(function (r, i) { r.checked = inp.options[i].value === v; });
      return;
    }
    if (f.sel) {
      inp.options.forEach(function (o, i) { if (o.value === v) { f.sel.value = String(i); } });
      return;
    }
    if (from !== 'num') {
      f.num.value = isNum(v) ? String(parseFloat((v * f.scale).toFixed(6))) : '';
    }
    if (f.rng) {
      var lo = parseFloat(f.rng.min), hi = parseFloat(f.rng.max), pos;
      if (from !== 'rng') {
        pos = f.mode === 'linear' ? (isNum(v) ? v * f.scale : lo) : toPos(inp, f.mode, isNum(v) ? v : inp.min);
        f.rng.value = String(pos);
      }
      pos = parseFloat(f.rng.value);
      var pct = hi > lo ? ((pos - lo) / (hi - lo)) * 100 : 0;
      f.rng.style.setProperty('--fill', (isNum(v) ? pct : 0).toFixed(2) + '%');
      f.rng.setAttribute('aria-valuetext', fmtInput(inp, v));
      f.rng.classList.toggle('is-empty', !isNum(v));
    }
    if (f.clear) { f.clear.hidden = !isNum(v); }
    f.wrap.classList.toggle('is-empty', inp.nullable && !isNum(v));
  };

  Calc.prototype.syncAll = function () {
    var self = this;
    Object.keys(this.fields).forEach(function (k) { self.sync(k); });
  };

  Calc.prototype.reset = function () {
    this.values = defaultsFor(this.model);
    this.syncAll();
    this.update();
    this.announce('Reset to defaults. ');
  };

  /* last-known-good numeric value for non-nullable inputs while a field is mid-edit */
  Calc.prototype.safeValues = function () {
    var v = {}, self = this;
    this.model.inputs.forEach(function (inp) {
      var x = self.values[inp.id];
      if (inp.type === 'currency' || inp.type === 'number' || inp.type === 'percent') {
        if (!isNum(x)) { x = inp.nullable ? null : (isNum(inp['default']) ? inp['default'] : (isNum(inp.min) ? inp.min : 0)); }
      }
      v[inp.id] = x;
    });
    return v;
  };

  Calc.prototype.update = function (first) {
    var self = this;
    var res = compute(this.model, this.safeValues());
    this.res = res;
    var prompts = res._prompts || {};
    var view = this.model.view;

    /* dependent inputs */
    var deps = DEPENDS[this.id] || {};
    Object.keys(deps).forEach(function (k) {
      var f = self.fields[k];
      if (f && f.wrap) { f.wrap.classList.toggle('is-muted', !self.values[deps[k]]); }
    });

    /* hero */
    var hdef = this.outDef(view.hero);
    var hv = res[view.hero];
    if (!isNum(hv) && prompts[view.hero]) {
      this.heroV.textContent = prompts[view.hero];
      this.heroV.classList.add('is-prompt');
      this.heroU.textContent = '';
      this.heroShown = null;
    } else {
      this.heroV.classList.remove('is-prompt');
      this.tweenHero(hv, hdef ? hdef.format : 'number', first);
      this.heroU.textContent = OUT_UNIT[view.hero] && isNum(hv) ? ' ' + OUT_UNIT[view.hero] : '';
    }
    this.heroSub.textContent = this.heroNote(res);
    if (this.mini) {
      this.mini.querySelector('.calc-mini-v').textContent = isNum(hv) ? fmt(hv, hdef.format) : (prompts[view.hero] || DASH);
    }

    /* tiles */
    view.tiles.forEach(function (oid) {
      var o = self.out[oid];
      if (!o) { return; }
      var val = res[oid];
      if (!isNum(val) && prompts[oid]) {
        o.v.textContent = prompts[oid];
        o.v.classList.add('is-prompt');
        o.u.textContent = '';
        o.sub.textContent = '';
        return;
      }
      o.v.classList.remove('is-prompt');
      o.v.textContent = fmt(val, o.def.format);
      o.u.textContent = isNum(val) && OUT_UNIT[oid] ? ' ' + OUT_UNIT[oid] : '';
      o.sub.textContent = (o.def.format === 'integer_compact' && isNum(val)) ? fmt(val, 'integer') + ' in full' : '';
    });

    /* extra visual / tables */
    this.renderExtra(res);
    this.updateAssumptions();
    if (!first) { this.queueAnnounce(); }
  };

  Calc.prototype.heroNote = function (res) {
    var v = this.safeValues();
    switch (this.id) {
      case 'fleet_value':
        return 'Over ' + v.years + ' years with ' + fmt(res.vehicles, 'integer') + ' wrapped ' + (res.vehicles === 1 ? 'vehicle' : 'vehicles') + '. A comparison with other media, not revenue or profit.';
      case 'cost_per_impression':
        return 'Spread over about ' + fmt(res.lifeImpressions, 'integer_compact') + ' estimated impressions in ' + v.years + (v.years === 1 ? ' year' : ' years') + '. An impression is a chance to be seen, not a lead.';
      case 'ownership_cost':
        return res.wrapCycles + (res.wrapCycles === 1 ? ' wrap' : ' wraps') + ' and ' + res.wrapRemovals + (res.wrapRemovals === 1 ? ' removal' : ' removals') + ' over ' + v.years + (v.years === 1 ? ' year' : ' years') + ', for ' + v.vehicles + (v.vehicles === 1 ? ' vehicle.' : ' vehicles.');
      case 'break_even':
        return isNum(res.oneEveryMonths) ? 'About one new customer every ' + fmt(res.oneEveryMonths, 'decimal_1') + ' months over a ' + v.years + '-year wrap life covers the cost.' : '';
    }
    return '';
  };

  /* Count-up from the last shown value. Time-based (wall clock, not frame count) with a timer
     that always lands on the final value, so a background tab, where animation frames pause,
     never leaves a stale mid-count number. Hidden tab or reduced motion: final value at once. */
  Calc.prototype.tweenHero = function (to, format, instant) {
    var self = this;
    var from = this.heroShown;
    this.heroShown = to;
    if (this.raf) { root.cancelAnimationFrame(this.raf); this.raf = null; }
    if (this.tweenT) { clearTimeout(this.tweenT); this.tweenT = null; }
    var hidden = typeof document !== 'undefined' && document.hidden;
    if (instant || hidden || !isNum(from) || !isNum(to) || reducedMotion() || from === to || typeof root.requestAnimationFrame !== 'function') {
      this.heroV.textContent = fmt(to, format);
      return;
    }
    var dur = 260;
    var now = function () { return (root.performance && root.performance.now) ? root.performance.now() : Date.now(); };
    var t0 = now();
    var finish = function () {
      if (self.raf) { root.cancelAnimationFrame(self.raf); self.raf = null; }
      if (self.tweenT) { clearTimeout(self.tweenT); self.tweenT = null; }
      self.heroV.textContent = fmt(to, format);
    };
    var step = function () {
      var k = Math.min(1, (now() - t0) / dur);
      if (k >= 1) { finish(); return; }
      var e = 1 - Math.pow(1 - k, 3);
      self.heroV.textContent = fmt(from + (to - from) * e, format);
      self.raf = root.requestAnimationFrame(step);
    };
    this.raf = root.requestAnimationFrame(step);
    this.tweenT = setTimeout(finish, dur + 80);
  };

  Calc.prototype.queueAnnounce = function () {
    var self = this;
    clearTimeout(this.annT);
    this.annT = setTimeout(function () { self.announce(''); }, 900);
  };
  Calc.prototype.announce = function (prefix) {
    var view = this.model.view, def = this.outDef(view.hero), res = this.res || {};
    var v = res[view.hero];
    var txt = (def ? def.label : 'Result') + ': ' + (isNum(v) ? fmt(v, def.format) : ((res._prompts || {})[view.hero] || 'not available'));
    this.live.textContent = (prefix || '') + txt;
  };

  /* ------------------------------------------------------ extra panels */
  function table(caption, head, rows, cls) {
    var t = h('table', { class: 'calc-table' + (cls ? ' ' + cls : '') });
    t.appendChild(h('caption', { class: 'calc-table-cap', text: caption }));
    var thead = h('thead');
    thead.appendChild(h('tr', null, head.map(function (c, i) { return h('th', { scope: 'col', class: i ? 'num' : '', text: c }); })));
    t.appendChild(thead);
    var tb = h('tbody');
    rows.forEach(function (r) {
      var tr = h('tr', { class: r.cls || '' });
      r.cells.forEach(function (c, i) {
        tr.appendChild(i === 0 ? h('th', { scope: 'row', text: c }) : h('td', { class: 'num', text: c }));
      });
      tb.appendChild(tr);
    });
    t.appendChild(tb);
    return h('div', { class: 'calc-table-wrap', tabindex: '0', role: 'region', 'aria-label': caption }, [t]);
  }

  function bars(caption, items) {
    var max = 0;
    items.forEach(function (it) { if (isNum(it.value) && Math.abs(it.value) > max) { max = Math.abs(it.value); } });
    var wrap = h('div', { class: 'calc-bars', role: 'img', 'aria-label': caption + ': ' + items.map(function (it) { return it.label + ' ' + it.text; }).join(', ') });
    wrap.appendChild(h('p', { class: 'calc-bars-cap', 'aria-hidden': 'true', text: caption }));
    items.forEach(function (it) {
      var pct = isNum(it.value) && max > 0 ? Math.max(2, Math.abs(it.value) / max * 100) : 0;
      var bar = h('span', { class: 'calc-bar-fill' + (it.holo ? ' is-holo' : '') + (isNum(it.value) ? '' : ' is-empty') });
      bar.style.width = (isNum(it.value) ? pct : 100) + '%';
      wrap.appendChild(h('div', { class: 'calc-bar', 'aria-hidden': 'true' }, [
        h('span', { class: 'calc-bar-k', text: it.label }),
        h('span', { class: 'calc-bar-track' }, [bar]),
        h('span', { class: 'calc-bar-v' + (isNum(it.value) ? '' : ' is-prompt'), text: it.text })
      ]));
    });
    return wrap;
  }

  Calc.prototype.renderExtra = function (res) {
    var self = this, v = this.safeValues(), x = this.extra, prompts = res._prompts || {};
    x.innerHTML = '';
    var lbl = function (oid) { var d = self.outDef(oid); return d ? d.label : oid; };
    if (this.id === 'fleet_value') {
      x.appendChild(bars('Investment vs estimated media-equivalent value', [
        { label: 'Wrap investment', value: res.investment, text: isNum(res.investment) ? fmt(res.investment, 'currency_0') : (prompts.investment || DASH) },
        { label: 'Media-equivalent value', value: res.mediaValue, text: fmt(res.mediaValue, 'currency_0'), holo: true }
      ]));
    } else if (this.id === 'cost_per_impression') {
      var base = v.impressions_per_mile;
      x.appendChild(table(lbl('sensitivity'), ['Impressions per mile', 'Your CPM'], res.sensitivity.map(function (s) {
        return { cells: [fmt(s.impressionsPerMile, 'number') + (s.multiplier === 1 ? ' (yours)' : ' (x' + s.multiplier + ')'), fmt(s.cpm, 'currency_2')], cls: s.impressionsPerMile === base && s.multiplier === 1 ? 'is-hl' : '' };
      })));
    } else if (this.id === 'ownership_cost') {
      var cols = [
        { k: 'wrap', label: 'Wrap', total: res.netWrap, prompt: null },
        { k: 'paint', label: 'Repaint', total: res.netPaint, prompt: prompts.netPaint },
        { k: 'ppf', label: 'PPF', total: res.netPpf, prompt: prompts.netPpf }
      ];
      x.appendChild(bars('Total over ownership', cols.map(function (c, i) {
        return { label: c.label, value: c.total, text: isNum(c.total) ? fmt(c.total, 'currency_0') : (c.prompt || DASH), holo: i === 0 };
      })));
      var cell = function (val, f, pr) { return isNum(val) ? fmt(val, f) : (pr || DASH); };
      x.appendChild(table('Each option over ' + v.years + (v.years === 1 ? ' year' : ' years'), ['', 'Wrap', 'Repaint', 'PPF'], [
        { cells: ['Total over ownership', cell(res.netWrap, 'currency_0'), cell(res.netPaint, 'currency_0', 'Add a quote'), cell(res.netPpf, 'currency_0', 'Add a quote')] },
        { cells: [lbl('perYear'), cell(res.perYear.wrap, 'currency_0'), cell(res.perYear.paint, 'currency_0', 'Add a quote'), cell(res.perYear.ppf, 'currency_0', 'Add a quote')] },
        { cells: [lbl('perMonth'), cell(res.perMonth.wrap, 'currency_2'), cell(res.perMonth.paint, 'currency_2', 'Add a quote'), cell(res.perMonth.ppf, 'currency_2', 'Add a quote')] }
      ], 'calc-table--cmp'));
      x.appendChild(table(lbl('wrapLifeSensitivity'), ['Wrap life', 'Wrap total'], res.wrapLifeSensitivity.map(function (s) {
        return { cells: [s.wrapLife + (s.wrapLife === 1 ? ' year' : ' years'), fmt(s.total, 'currency_0')], cls: s.wrapLife === v.wrap_life ? 'is-hl' : '' };
      })));
    } else if (this.id === 'break_even') {
      var K = this.model.constants;
      var head = ['Margin, by job value'].concat(K.grid_job_values.map(function (j) { return fmt(j, 'currency_0'); }));
      x.appendChild(table(lbl('grid'), head, K.grid_margins.map(function (m, ri) {
        return {
          cells: [fmt(m, 'percent_0')].concat(res.grid[ri].map(function (c) { return fmt(c, 'integer'); })),
          cls: Math.abs(m - v.margin) < 1e-9 ? 'is-hl' : ''
        };
      }), 'calc-table--grid'));
    }
  };

  /* -------------------------------------------------- assumptions list */
  Calc.prototype.assumptions = function () {
    var self = this, m = this.model;
    var det = h('details', { class: 'calc-assume' });
    var count = m.inputs.length + Object.keys(m.constants).length;
    det.appendChild(h('summary', { class: 'calc-assume-sum' }, [
      h('span', { class: 'calc-assume-k', text: 'Assumptions and sources' }),
      h('span', { class: 'calc-assume-n', text: count + ' items' })
    ]));
    var body = h('div', { class: 'calc-assume-body' });
    var tbl = h('table', { class: 'calc-table calc-table--assume' });
    tbl.appendChild(h('caption', { class: 'cwv-sr-only', text: 'Every input and constant, its default, your value and its source' }));
    tbl.appendChild(h('thead', null, [h('tr', null, [
      h('th', { scope: 'col', text: 'Input' }), h('th', { scope: 'col', text: 'Default' }),
      h('th', { scope: 'col', text: 'Yours' }), h('th', { scope: 'col', text: 'Source' })
    ])]));
    var tb = h('tbody');
    this.assumeCells = {};
    m.inputs.forEach(function (inp) {
      var yours = h('td', { class: 'calc-assume-yours' });
      self.assumeCells[inp.id] = yours;
      tb.appendChild(h('tr', { 'data-a': inp.id }, [
        h('th', { scope: 'row', text: inp.label }),
        h('td', { text: inp.type === 'rows' ? self.rowsText(inp, inp['default']) : fmtInput(inp, inp['default']) }),
        yours,
        h('td', { class: 'calc-assume-src', text: inp.source || '' })
      ]));
      var opts = inp.options || (inp.row_fields && inp.row_fields[0].options);
      if (opts && opts.some(function (o) { return o.source || isNum(o.factor) || 'price' in o; })) {
        opts.forEach(function (o) {
          var val = isNum(o.factor) ? 'x' + o.factor : ('price' in o ? (isNum(o.price) ? fmt(o.price, 'currency_0') + ' · ' + o.coverage : 'No published price · ' + o.coverage) : '');
          tb.appendChild(h('tr', { class: 'is-sub' }, [
            h('th', { scope: 'row', text: o.label }), h('td', { text: val }), h('td', { text: '' }),
            h('td', { class: 'calc-assume-src', text: o.source || inp.source || '' })
          ]));
        });
      }
    });
    Object.keys(m.constants).forEach(function (k) {
      var d = m.constantDefs[k], val = m.constants[k];
      var txt = Array.isArray(val) ? val.map(function (x) { return d.unit === 'USD' ? fmt(x, 'currency_0') : (d.unit === 'fraction' ? fmt(x, 'percent_0') : String(x)); }).join(', ') : String(val) + (d.unit ? ' ' + d.unit : '');
      tb.appendChild(h('tr', { class: 'is-const' }, [
        h('th', { scope: 'row', text: d.label }), h('td', { text: txt }), h('td', { text: 'Constant' }),
        h('td', { class: 'calc-assume-src', text: d.source })
      ]));
    });
    tbl.appendChild(tb);
    body.appendChild(h('div', { class: 'calc-table-wrap', tabindex: '0', role: 'region', 'aria-label': 'Assumptions and sources' }, [tbl]));
    if (m.notes.length) {
      body.appendChild(h('p', { class: 'calc-assume-note', text: 'This page changes some defaults from the ROI Lab standard: ' + m.notes.join(', ') + '.' }));
    }
    var mountData = this.mount.dataset || {};
    if (mountData.hasDisclaimer !== 'true' && m.src.disclaimer) {
      body.appendChild(h('p', { class: 'calc-assume-disc', text: m.src.disclaimer }));
    }
    if (mountData.hasHow !== 'true' && m.src.how_we_calculate && m.src.how_we_calculate.length) {
      body.appendChild(h('p', { class: 'calc-assume-k2', text: 'How we calculate' }));
      body.appendChild(h('ul', { class: 'calc-assume-how' }, m.src.how_we_calculate.map(function (t) { return h('li', { text: t }); })));
    }
    det.appendChild(body);
    return det;
  };

  Calc.prototype.rowsText = function (inp, rows) {
    if (!Array.isArray(rows)) { return ''; }
    var opts = inp.row_fields[0].options;
    return rows.map(function (r) {
      var o = findOpt(opts, r.vehicle_type);
      return r.count + ' x ' + (o ? o.label : r.vehicle_type) + ' at ' + (isNum(r.price) ? fmt(r.price, 'currency_0') : 'your quote');
    }).join('; ');
  };

  Calc.prototype.updateAssumptions = function () {
    var self = this;
    if (!this.assumeCells) { return; }
    this.model.inputs.forEach(function (inp) {
      var cell = self.assumeCells[inp.id];
      if (!cell) { return; }
      var v = self.values[inp.id];
      var txt = inp.type === 'rows' ? self.rowsText(inp, v) : fmtInput(inp, v);
      var changed = JSON.stringify(v) !== JSON.stringify(inp['default']);
      cell.textContent = changed ? txt : 'Default';
      cell.classList.toggle('is-changed', changed);
    });
  };

  /* --------------------------------------------------------------- init */
  function initAll(scope) {
    if (!scope || !scope.querySelectorAll) { return; }
    var mounts = scope.querySelectorAll('[data-cwv-calc]');
    for (var i = 0; i < mounts.length; i++) {
      var el = mounts[i];
      if (el.__cwvCalc) { continue; }
      try { el.__cwvCalc = new Calc(el); } catch (e) { if (root.console) { root.console.error('[CWV calculator]', e); } }
    }
  }

  CWV.calc = {
    __loaded: true,
    defs: SRC,
    map: MAP,
    constants: CONSTANTS,
    buildModel: buildModel,
    defaults: function (id, config) { var m = buildModel(id, config); return m ? defaultsFor(m) : null; },
    compute: function (id, values, config) {
      var m = buildModel(id, config);
      if (!m) { return null; }
      var v = defaultsFor(m);
      if (values) { Object.keys(values).forEach(function (k) { v[k] = values[k]; }); }
      return compute(m, v);
    },
    format: fmt,
    initAll: initAll
  };

  if (typeof module !== 'undefined' && module.exports) { module.exports = CWV.calc; }

  if (typeof document !== 'undefined') {
    var start = function () { initAll(document); };
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); } else { start(); }
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  }
})(typeof window !== 'undefined' ? window : globalThis);
